export function getFriendlyDay(dateStr: string) {
  // destructure date parts manually
  const [y, m, d] = dateStr.split("-").map(Number);

  // create a local date, no UTC involved
  const gameDate = new Date(y, m - 1, d); // ✅ this is 12am local time

  const now = new Date();
  now.setHours(0, 0, 0, 0); // clamp to local midnight

  const msPerDay = 24 * 60 * 60 * 1000;
  const diff = Math.round((gameDate.getTime() - now.getTime()) / msPerDay);

  if (diff === -1) return "Yesterday";
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === 2) {
    return gameDate.toLocaleDateString("en-US", { weekday: "long" });
  }

  return gameDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}
